export const URLS = Object.freeze({
    linkedIn: 'https://www.linkedin.com/in/michaeljamesxjr',
    gitHub: 'https://github.com/ir0nCr055',
    stackOverflow: 'https://stackoverflow.com/users/2333933/mike-c',
    clientPortal: 'https://mhps.invoicing.co/client/login',
    public: 'https://www.mhps.io'
})